import { AnimatePresence, motion } from 'framer-motion'
import { navigate } from 'gatsby'
import React, { useCallback, useState } from 'react'

import Box from '@/modules/components/Box'
import Icon from '@/modules/components/Icon'
import Input from '@/modules/components/Input'

export const SearchBar = () => {
  const [toggle, setToggle] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>('')
  const searchOnChange = useCallback((e: any) => {
    setSearchValue(e?.target?.value ?? '')
  }, [])
  const onSearch = useCallback(() => {
    navigate(`/search/?keyword=${searchValue}`, { replace: false })
    setToggle(false)
  }, [searchValue])

  return (
    <Box
      display={['none', 'none', 'flex']}
      marginRight={'40px'}
      position="relative"
      height="39px"
      width="27px"
    >
      <div style={{ position: 'absolute', right: '0px' }}>
        <motion.div
          initial={'init'}
          animate={toggle ? 'open' : 'close'}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '6px 0px',
          }}
          variants={{
            init: {
              backgroundColor: '#06112100',
              width: '27px',
              borderBottom: '1px solid rgba(255,255,255,0)',
            },
            open: {
              backgroundColor: [null, '#06112100', '#061121'],
              width: [null, '502px', '502px'],
              borderBottom: [
                null,
                '1px solid rgba(255,255,255,0)',
                '1px solid rgba(255,255,255,0.3)',
              ],
              transition: { times: [0, 0.2, 1], duration: 0.4 },
            },
            close: {
              backgroundColor: [null, '#06112100', '#06112100'],
              width: [null, '502px', '27px'],
              borderBottom: [
                null,
                '1px solid rgba(255,255,255,0)',
                '1px solid rgba(255,255,255,0)',
              ],
              transition: { times: [0, 0.8, 1], duration: 0.4 },
            },
          }}
        >
          <Icon.Search
            fontSize="27px"
            tabIndex={0}
            role="button"
            opacity={toggle ? 1 : 0.5}
            customCss={{
              '&:hover': {
                opacity: 1,
              },
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === 'Space') {
                if (!toggle) {
                  setToggle(true)
                } else {
                  onSearch()
                }
              }
            }}
            onClick={() => {
              if (!toggle) {
                setToggle(true)
              } else {
                onSearch()
              }
            }}
          />
          <AnimatePresence initial={false}>
            {toggle && (
              <motion.div
                key="content"
                initial="hide"
                animate="open"
                exit="hide"
                style={{
                  display: 'flex',
                }}
                variants={{
                  open: { width: '100%', paddingLeft: '12px', opacity: 1 },
                  hide: { width: 0, paddingLeft: '0px', opacity: 0 },
                }}
                transition={{ type: 'easeInOut', duration: 0.4 }}
              >
                <Input
                  width="100%"
                  variant="searchBar"
                  onChange={searchOnChange}
                  value={searchValue}
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') onSearch()
                  }}
                />

                <Icon.SearchClose
                  display={toggle ? 'flex' : 'none'}
                  fontSize="20px"
                  tabIndex={0}
                  role="button"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === 'Space') setToggle(false)
                  }}
                  onClick={() => {
                    setToggle(false)
                  }}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </Box>
  )
}
